const initialState = {
    buyPlan: '',
    buyAmount: '',
    paymentApiCase: '',
    paymentTextCase: '',
    seatNumber: -1,
    isPaymentActive: false,
    isPaymentGuideActive: false,
    paymentGuideMinPlan: "",
}
// paymentTextCase :
//  trialing: 試用中
//  trialedOrCanceled: 已試用過，未購買過
//  dad: 已購買過
//  canTrial: 未試用，未購買，非試用中
//  changeCard: 換卡
const Payment = (state = initialState, action = {}) => {
    switch (action.type) {
        case 'togglePaymentField': {
            return {
                ...state,
                paymentApiCase: action.paymentApiCase || '', // 試用,升級或購買
                paymentTextCase: action.paymentTextCase || '',
                buyPlan: action.buyPlan || '',
                buyAmount: action.buyAmount || '',
                seatNumber: action.seatNumber || -1, /*PM弄的 Agency Payment*/
                isPaymentActive: action.isPaymentActive,
                isPaymentGuideActive: action.isPaymentGuideActive,
                paymentGuideMinPlan: action.paymentGuideMinPlan,
            }
        }
        default:
            return state;
    }
}
export default Payment;


// WEBPACK FOOTER //
// ./src/reducer/Payment.js